
  import pwa from '~/mixins/pages/pwa'
  import { PIXEL_EVENTS } from '~/utils/constants'
  export default {
    name: 'ThemeStoresMobileIosAppSection',
    mixins: [pwa],
    data() {
      return {
        showModal: false,
        modalTranslateY: 550
      }
    },
    computed: {
      pwa() {
        return this.$store.state['banner-pwa'].pwa
      },
      appIcon() {
        if (!this.pwa?.pwa_app_settings?.app_icon) return null
        return `${this.$config.BUCKET_ROOT}/assets/banners/app_icons/${this.pwa?.pwa_app_settings?.app_icon}`
      }
    },
    methods: {
      onOpenModal() {
        this.trackPixelEvent(PIXEL_EVENTS.downloadAction, null, null, null, false, null, true)
        this.showModal = true
        setTimeout(() => {
          this.modalTranslateY = 0
        }, 1)
      },
      onCloseModal() {
        this.modalTranslateY = 550
        setTimeout(() => {
          this.showModal = false
        }, 300)
      }
    }
  }
